import { ReactNode } from 'react';

import { ChakraProvider } from '@chakra-ui/react';
import { theme } from '@this+that/app-config';

import { ThemeProvider } from './ThemeContext';
import { UserSetupProvider } from '../providers/UserSetupProvider';

export function AppContext({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <ThemeProvider>
      <ChakraProvider theme={theme}>
        <UserSetupProvider>{children}</UserSetupProvider>
      </ChakraProvider>
    </ThemeProvider>
  );
}
